FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    var ELEM = '.fd-table';

    $.widget("custom.tableInPage", {
        _sortCtrl: {
            none: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-sort'></i></span>",
            asc: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-caret-up' ></i></span>",
            desc: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-caret-down'></i></span>",
        },
        _scrollDelay: null,
        _sortTHList: null,
        _currentSortID: null,

        options: {
            collapserow: false,
            fixedheader: false,
            fixedcontainer: null,
            sort: false,
            defaultScrollbarWidth: 17,
            zIndex: 112
        },
        _create: function () {
            $.extend(this.options, this.element.data());

            if (this.options.sort) {
                this._setSortableColumn();
            }
            
            if (this.options.fixedheader && this.element[0].offsetParent) {
                this._setFixedHeader();
            }
            if (this.options.collapserow) {
                this._setCollapseRow();
            }

            this.element.addClass("table-in-page");
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.refresh();
        },
        refresh: function () {

        },
        _destroy: function () {
            this.element.removeClass("table-in-page");

            $(document).off('click.sort', '.sort-control', this._handleColumnSort);

            var id = me.getUID('TBL_');
            $('#' + id).off('click', '', this._handleCollapseHandle);
            this.element.find(".COLLAPSEHANDLE").remove();

            this.element.floatThead("destroy");
            this._sortTHList?.find('.sort-ctrl').remove();

            if (this._scrollDelay) {
                clearTimeout(this._scrollDelay);
            }
        },

        
        _setFixedHeader: function () {
            var self = this;

            if (this.options.headerfixset || this.options.headerfixset === true) {
                this.element.floatThead("destroy");
            }
            if (this.options.fixedcontainer) {
                if (!this.element.hasClass('wp-100') && this.element.closest(this.options.fixedcontainer).width() - this.element.outerWidth() >= this.options.defaultScrollbarWidth) {
                    this.element.closest(this.options.fixedcontainer).css('overflow-y', 'scroll'); // Necessary to correctly set width in Internet Explorer
                }
                if (this.options.sizingrow !== undefined) {
                    this.element.floatThead({
                        scrollContainer: function ($table) {
                            return $table.closest(self.options.fixedcontainer);
                        },
                        getSizingRow: function ($table, $cols, $fthCells) {
                            return $table.find('tbody tr:eq(' + self.options('sizingrow') + ') td');
                        },
                        zIndex: this.options.zIndex,
                        support: {
                            perfectScrollbar: true
                        }
                    });
                } else {
                    this.element.floatThead({
                        scrollContainer: function ($table) {
                            return $table.closest(self.options.fixedcontainer);
                        },
                        zIndex: this.options.zIndex
                    });
                }
            } else {
                this.element.floatThead({
                    top: $('.site-fixed-top-content').height() + $('.site-top-navigation').height() - 1,
                    zIndex: this.options.zIndex
                });
            }
            this.options.headerfixset = true;
            this.element.attr('data-headerfixset', true);
        },


        //  Enable ability to collapse rows so that text doesn't wrap (hides overflow)
        _setCollapseRow: function() {
            var firstTH = this.element.find("th:first-child");
            var collapseIcon = (this.options.isrowcollapsed) ? "fa-expand" : "fa-compress";
            var id = me.getUID('TBL_');
            var collapseElem = "<div class='collapse-handle'><a id='" + id + "' class='COLLAPSETABLE' href='#'><i class='fa " + collapseIcon + "'></i></a></div>";

            this.element.find(".COLLAPSEHANDLE").remove();
            firstTH.append(collapseElem);
            $('#' + id).on('click', '', this, this._handleCollapseHandle);
        },
        _handleCollapseHandle: function (event) {
            event.preventDefault();
            var self = event.data;

            if (self.element.hasClass('nowrap')) {
                self.element.removeClass('nowrap');
                $(this).children('i').removeClass('fa-expand').addClass('fa-compress');
                element.data('isrowcollapsed', false).attr('isrowcollapsed', false);
            } else {
                self.element.addClass('nowrap');
                $(this).children('i').removeClass('fa-compress').addClass('fa-expand');
                self.element.data('isrowcollapsed', true).attr('isrowcollapsed', true);
            }
        },


        //  sortable column
        _setSortableColumn: function () {
            var self = this;
            var options = {
                tag: this.options.sorttag || 82,
                callback: me.setCallBackPrefix(this.options.callbackprefix || 1),
                sortid: 0
            };
            this._sortTHList = this.element.find("th[data-fd='thsort']");
            if (this._sortTHList.length) {
                this._sortTHList.each(function (i) {
                    var th = $(this);
                    if (th.data('direction') != undefined) {
                        options.direction = th.data('direction').toString();
                        options.initialdir = th.data('initialdir');
                    } else {
                        options.direction = 'none';
                        options.initialdir = th.data('initialdir');
                    }
                    options.sortfield = th.data('sortfield') || 'noFldName';

                    th.data(options).attr('id', me.getUID('SRT_'));

                    self._setSortColumnIcon(th, options.direction);
                });

                $(document).on('click.sort', '.sort-control', this, this._handleColumnSort);
            }
        },
        _setSortColumnIcon: function (th, direction) {
            direction = direction.toLowerCase();
            th.removeClass('sort-control').find('.sort-ctrl').remove();

            switch (direction) {
                case '0':
                case 'asc':
                case 'ascending':
                    th.prepend(this._sortCtrl.asc).addClass('sort-control').addClass('in').data('sortid', 0);
                    break;
                case '1':
                case 'desc':
                case 'descending':
                    th.prepend(this._sortCtrl.desc).addClass('sort-control').addClass('in').data('sortid', 1);
                    break;
                default:
                    th.prepend(this._sortCtrl.none).addClass('sort-control').removeClass('in').data('sortid', -1);
                    break;
            }
        },
        _handleColumnSort: function (event) {
            if ($(event.target).is("input,select,textara")) {
                return;
            }
            event.preventDefault();

            var self = event.data;

            var th = $(this);
            var data = th.data();

            if (self._currentSortID !== null || self._currentSortID !== th.attr('id')) {
                self._sortTHList.not(this).each(function (i) {
                    var child = $(this);
                    self._setSortColumnIcon(child, 'none');
                });
            }

            if (this._scrollDelay) {
                clearTimeout(this._scrollDelay);
            }
            this._scrollDelay = setTimeout(function () {
                th.find('.sort-ctrl').remove();

                switch (data.sortid) {
                    case 0:
                        th.prepend(self._sortCtrl.desc).addClass('in');
                        th.data('sortid', 1);
                        break;
                    case 1:
                        th.prepend(self._sortCtrl.asc).addClass('in');
                        th.data('sortid', 0)
                        break;
                    default:
                        if (data.initialdir == 0 || (typeof data.initialdir === 'string' && data.initialdir.toLowerCase().startsWith('asc'))) {
                            th.prepend(self._sortCtrl.asc).addClass('in');
                            th.data('sortid', 0);
                        } else {
                            th.prepend(self._sortCtrl.desc).addClass('in');
                            th.data('sortid', 1);
                        }
                        break;
                }

                data = th.data();
                me.setCallBackFromData(th, { e: th, value: data.sortid, tag: data.tag, sortfield: data.sortfield, parentid: null });
            }, 300);
        }, 

        resetFixedTableHeader: function () {
            if (this.options.fixedcontainer) {
                this.element.floatThead('reflow');
            } else {
                this.element.floatThead('destroy');
                this.element.floatThead({
                    top: $('.site-fixed-top-content').height() + $('.site-top-navigation').height() - 1,
                    zIndex: this.options.zIndex
                });
            }
            this.element.attr('data-headerfixset', true);
        }

    });

    //  set table in page
    child.setTableInPage = function (container, defaults) {
        var list = '';
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.is(ELEM) ? container : container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        list.filter((i, self) => $(self).hasClass("table-in-page")).tableInPage("destroy");
        list.tableInPage(defaults);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));